/* eslint-disable react-hooks/exhaustive-deps */
import './PopPupChung.scss'
import { useEffect } from 'react'
function PopPupChung ({
  isOpen,
  setisOpen,
  animateOut,
  setAnimateOut,
  children,
  paddingnone

}) {
  const handleClose = () => {
    setAnimateOut(true)
  }

  useEffect(() => {
    if (animateOut) {
      const timer = setTimeout(() => {
        setisOpen(false)
        setAnimateOut(false)
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [animateOut, setisOpen])

  if (!isOpen) return null

  return (
    <div
      className={`overlay_popup_chung ${
        animateOut ? 'fade-out-overlay' : 'fade-in-overlay'
      }`}
      onClick={handleClose}
    >
      <div
        className={`popup_chung ${
          animateOut ? 'scale-down-center' : 'scale-up-center'
        } ${paddingnone ? 'paddingnone' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )
}

export default PopPupChung
